import { render, staticRenderFns } from "./ComplainForm.vue?vue&type=template&id=ad79325a&"
import script from "./ComplainForm.vue?vue&type=script&lang=js&"
export * from "./ComplainForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports